import { render, staticRenderFns } from "./WorldstridesEnvisionAuth.vue?vue&type=template&id=10580afe&"
import script from "./WorldstridesEnvisionAuth.vue?vue&type=script&lang=js&"
export * from "./WorldstridesEnvisionAuth.vue?vue&type=script&lang=js&"
import style0 from "vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&lang=css&"
import style1 from "./WorldstridesEnvisionAuth.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports